import React, { useState, useEffect } from 'react';
import DoMore from '../../Components/DoMore/DoMore'
import Hero from '../../Components/Hero/Hero'
import AtmLocatinos from '../../Components/AtmLocations/AtmLocatinos'
import SavePlusAccount from '../../Components/SavePlusAccount/SavePlusAccountComponent'
import IndoBankingSlider from '../../Components/IndoBankingSlider/IndoBankingSlider'
import AllAccounts from "../../Components/AllAccounts/AllAccounts";
import ContactForm from "../../Components/ContactForm/ContactForm";
import CustomerCare from "../../Components/CustomerCare/CustomerCare";
import OurStores from "../../Components/OurStories/OurStores";
import './Homepage.css';
import NewsSlider from '../../Components/News/NewsSlider';
import VideoPopup from '../../Components/VideoPopup/VideoPopup';
const Homepage = () => {
const img = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_3Short.png"
const accountContent = "Exclusively designed savings account to inculcate savings habits in parents and guardians for their children. This savings account offers attractive interest rates and other benefits to realize your savings goals with other value added features such as IZB Contactless Visa Card, SMS Alert, Mobile and Internet Banking facility."

useEffect(() => {
  window.scrollTo(0, 0)
}, [])

 return (
    <React.Fragment>
      <Hero/>  
      <NewsSlider />
      <DoMore/> 
      <AtmLocatinos/>
      <SavePlusAccount heading="Save Plus Account" subHeading="Secure your Childs Futures with our" content={accountContent} img={img} btnTxt="Open an Account" link="/SavePlusAccount"/>
      <IndoBankingSlider/>
      <AllAccounts />
      <ContactForm />
      <CustomerCare />
      <OurStores />
      {/* <VideoPopup videoUrl="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here-video.mp4" /> */}
    </React.Fragment>
  )
}

export default Homepage